<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  span {
    @include mixins.body3-tooltip-and-caption();
    color: colors.get(textGrey);
  }
</style>

<script>
  let { skeleton = false, length, start, total } = $props();

  let n = $derived(Math.min(start + 1, total));
  let m = $derived(Math.min(start + length, total));
</script>

<span class:skeleton> Results: {n}-{m} of {total}</span>
